import { Component } from '@angular/core';
import { TenantService } from '../../services/tenant.service';

@Component({
  selector: 'app-giveaway',
  templateUrl: './giveaway.component.html',
  styleUrls: ['./giveaway.component.css']
})
export class GiveawayComponent {
	tenant: TenantService;

	constructor(private tenantService: TenantService) {
		this.tenant = tenantService;
	}
}
